const mixin = {
  methods: {
    getIconForArticleType: function (articleType) {
      let icon = 'fa-'

      switch (articleType) {
        case 'key':
          return icon + 'file-text'
        case 'video':
          return icon + 'video-camera'
        case 'blog':
          return icon + 'comment'
        case 'infographic':
          return icon + 'pie-chart'
        default:
          return icon + 'file-text'
      }
    },

    formatDate: function (dateString, language) {
      if (!language) {
        language = this.$lang
      }

      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      const monthNamesRS = ['Januar', 'Februar', 'Mart', 'April', 'Maj', 'Jun', 'Jul', 'Avgust', 'Septembar', 'Oktobar', 'Novembar', 'Decembar']

      const date = new Date(dateString)
      const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      const month = language === 'en' ? monthNames[date.getMonth()] : monthNamesRS[date.getMonth()]

      return day + '. ' + month + ' ' + date.getFullYear()
    },

    checkArticlePublishDate: function (publishDate) {
      const now = new Date()
      const when = new Date(publishDate)
      return when < now
    }
  }
}

export default {
  install(Vue, options) {
    Vue.mixin(mixin)
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js